export default __webpack_public_path__ + "static/media/img-0319-madagascar-half-face.d770ba8e.png";